function createRecord(container, options) {
    if (!container) return;

    var size = options.size || 498;
    var spinText = options.spinText || 'Welcome Welcome Welcome Welcome Welcome Welcome ';
    var spinFontSize = options.spinFontSize || 18;
    var spinRadius = options.spinRadius || 200;
    var type = options.type || 'hero';
    var initialRotation = options.initialRotation || 0;

    var wrapper = document.createElement('div');
    wrapper.style.position = 'relative';
    wrapper.style.width = size + 'px';
    wrapper.style.height = size + 'px';

    if (type === 'footer') {
        wrapper.style.transform = 'rotate(66.98deg)';
        wrapper.style.transformOrigin = 'center';
    }

    var gradId = container.id + 'Grad';
    var innerGradId = container.id + 'Inner';

    var outerStop1 = type === 'footer' ? 'black' : 'black';
    var outerStop2 = type === 'footer' ? '#2F2F2F' : '#5B5B5B';
    var centerDotColor = type === 'footer' ? '#1E232A' : '#F3F5F7';

    var outerX1, outerY1, outerX2, outerY2;
    if (type === 'footer') {
        outerX1 = size * 0.77; outerY1 = size * 0.89;
        outerX2 = size * 0.41; outerY2 = size * 0.09;
    } else {
        outerX1 = size * 0.135; outerY1 = size * 0.438;
        outerX2 = size * 0.691; outerY2 = size * 0.296;
    }

    var svgNS = 'http://www.w3.org/2000/svg';

    var svg = document.createElementNS(svgNS, 'svg');
    svg.setAttribute('viewBox', '0 0 ' + size + ' ' + size);
    svg.setAttribute('fill', 'none');
    svg.style.position = 'absolute';
    svg.style.inset = '0';
    svg.style.width = '100%';
    svg.style.height = '100%';

    var defs = document.createElementNS(svgNS, 'defs');

    var grad = document.createElementNS(svgNS, 'linearGradient');
    grad.id = gradId;
    grad.setAttribute('x1', outerX1);
    grad.setAttribute('y1', outerY1);
    grad.setAttribute('x2', outerX2);
    grad.setAttribute('y2', outerY2);
    grad.setAttribute('gradientUnits', 'userSpaceOnUse');
    var s1 = document.createElementNS(svgNS, 'stop');
    s1.setAttribute('stop-color', outerStop1);
    var s2 = document.createElementNS(svgNS, 'stop');
    s2.setAttribute('offset', '1');
    s2.setAttribute('stop-color', outerStop2);
    grad.appendChild(s1);
    grad.appendChild(s2);
    defs.appendChild(grad);

    var innerGrad = document.createElementNS(svgNS, 'linearGradient');
    innerGrad.id = innerGradId;
    if (type === 'footer') {
        innerGrad.setAttribute('x1', '62');
        innerGrad.setAttribute('y1', '73');
        innerGrad.setAttribute('x2', '23');
        innerGrad.setAttribute('y2', '8');
    } else {
        innerGrad.setAttribute('x1', '127');
        innerGrad.setAttribute('y1', '153');
        innerGrad.setAttribute('x2', '48');
        innerGrad.setAttribute('y2', '17');
    }
    innerGrad.setAttribute('gradientUnits', 'userSpaceOnUse');
    var is1 = document.createElementNS(svgNS, 'stop');
    is1.setAttribute('stop-color', '#009AF7');
    var is2 = document.createElementNS(svgNS, 'stop');
    is2.setAttribute('offset', '1');
    is2.setAttribute('stop-color', '#95CAFF');
    innerGrad.appendChild(is1);
    innerGrad.appendChild(is2);
    defs.appendChild(innerGrad);

    svg.appendChild(defs);

    var outerCircle = document.createElementNS(svgNS, 'circle');
    outerCircle.setAttribute('cx', size / 2);
    outerCircle.setAttribute('cy', size / 2);
    outerCircle.setAttribute('r', size / 2 - 1);
    outerCircle.setAttribute('fill', 'url(#' + gradId + ')');
    svg.appendChild(outerCircle);

    wrapper.appendChild(svg);

    var innerSvg = document.createElementNS(svgNS, 'svg');
    innerSvg.style.position = 'absolute';
    var innerSize = size * 0.34;
    var innerOffset = size * 0.33;
    innerSvg.style.left = innerOffset + 'px';
    innerSvg.style.top = innerOffset + 'px';
    innerSvg.style.width = innerSize + 'px';
    innerSvg.style.height = innerSize + 'px';

    if (type === 'footer') {
        innerSvg.setAttribute('viewBox', '0 0 82 81');
        var innerEllipse = document.createElementNS(svgNS, 'ellipse');
        innerEllipse.setAttribute('cx', '41');
        innerEllipse.setAttribute('cy', '40.5');
        innerEllipse.setAttribute('rx', '41');
        innerEllipse.setAttribute('ry', '40.5');
        innerEllipse.setAttribute('fill', 'url(#' + innerGradId + ')');
        innerSvg.appendChild(innerEllipse);
    } else {
        innerSvg.setAttribute('viewBox', '0 0 170 170');
        var innerCircle = document.createElementNS(svgNS, 'circle');
        innerCircle.setAttribute('cx', '85');
        innerCircle.setAttribute('cy', '85');
        innerCircle.setAttribute('r', '85');
        innerCircle.setAttribute('fill', 'url(#' + innerGradId + ')');
        innerSvg.appendChild(innerCircle);
    }

    innerSvg.setAttribute('fill', 'none');
    wrapper.appendChild(innerSvg);

    var dotSize = size * (type === 'footer' ? 0.022 : 0.023);
    var dot = document.createElement('div');
    dot.style.position = 'absolute';
    dot.style.borderRadius = '50%';
    dot.style.background = centerDotColor;
    dot.style.width = dotSize + 'px';
    dot.style.height = dotSize + 'px';
    dot.style.left = (size / 2 - dotSize / 2) + 'px';
    dot.style.top = (size / 2 - dotSize / 2) + 'px';
    wrapper.appendChild(dot);

    var spinContainer = document.createElement('div');
    spinContainer.style.position = 'absolute';
    spinContainer.style.inset = '0';
    wrapper.appendChild(spinContainer);

    var chars = spinText.split('');
    var anglePerChar = 360 / chars.length;

    chars.forEach(function (char, i) {
        var span = document.createElement('span');
        span.style.position = 'absolute';
        span.style.left = '50%';
        span.style.fontFamily = "'DM Mono', monospace";
        span.style.color = '#fff';
        span.style.textTransform = 'lowercase';
        span.style.lineHeight = '1';
        span.style.top = (size / 2 - spinRadius) + 'px';
        span.style.fontSize = spinFontSize + 'px';
        span.style.transformOrigin = '0px ' + spinRadius + 'px';
        span.style.transform = 'rotate(' + (anglePerChar * i) + 'deg)';
        span.textContent = char === ' ' ? '\u00A0' : char;
        spinContainer.appendChild(span);
    });

    container.appendChild(wrapper);

    var rotation = initialRotation;
    var lastTime = performance.now();

    function animate(time) {
        var delta = time - lastTime;
        lastTime = time;
        rotation = (rotation + delta * 0.02) % 360;
        spinContainer.style.transform = 'rotate(' + rotation + 'deg)';
        requestAnimationFrame(animate);
    }

    requestAnimationFrame(animate);
}

export default function initRecords() {
    var heroSpinText = 'Welcome Welcome Welcome Welcome Welcome Welcome ';
    var footerSpinText = 'Contact Contact Contact Contact Contact Contact ';

    var heroDesktop = document.getElementById('heroRecordDesktop');
    if (heroDesktop) {
        createRecord(heroDesktop, {
            size: 498,
            spinRadius: 200,
            spinFontSize: 18,
            spinText: heroSpinText,
            type: 'hero'
        });
    }

    var heroMobile = document.getElementById('heroRecordMobile');
    if (heroMobile) {
        createRecord(heroMobile, {
            size: 306,
            spinRadius: 122,
            spinFontSize: 11,
            spinText: heroSpinText,
            type: 'hero'
        });
    }

    var footerDesktop = document.getElementById('footerRecordDesktop');
    if (footerDesktop) {
        createRecord(footerDesktop, {
            size: 240,
            spinRadius: 240 * 0.38,
            spinFontSize: 240 * 0.048,
            spinText: footerSpinText,
            type: 'footer'
        });
    }

    var footerMobile = document.getElementById('footerRecordMobile');
    if (footerMobile) {
        createRecord(footerMobile, {
            size: 222,
            spinRadius: 222 * 0.38,
            spinFontSize: 222 * 0.048,
            spinText: footerSpinText,
            type: 'footer'
        });
    }
}
